import { i18nImportInit } from 'services/i18next/i18nImportInit';

export const loadLocizeTranslations = async (brand: string, lang: string) => {
  try {
    await i18nImportInit({
      brand,
      lang,
    });
  } catch (error) {
    console.error('load translations error', error);
  }
};
